<template>
	<section class="modal-card-body">
		<div class="columns">
			<proforma-invoice-settings :car="car"></proforma-invoice-settings>
		</div>
		<div class="columns">
			<proforma-invoice-sales-table :car="car"></proforma-invoice-sales-table>
		</div>
		<div class="columns">
			<proforma-invoice-dates :car="car"></proforma-invoice-dates>
			<proforma-invoice-sub-total :car="car"></proforma-invoice-sub-total>
		</div>
		<div class="columns">
			<proforma-invoice-costs-table :car="car"></proforma-invoice-costs-table>
		</div>
		<div class="columns">
			<proforma-invoice-in-charge :car="car"></proforma-invoice-in-charge>
			<proforma-invoice-total :car="car"></proforma-invoice-total>
		</div>
	</section>
</template>

<script>
	import ProformaInvoiceSettings from './ProformaInvoiceSettings'
	import ProformaInvoiceDates from './ProformaInvoiceDates'
	import ProformaInvoiceSubTotal from './ProformaInvoiceSubTotal'
	import ProformaInvoiceCostsTable from './ProformaInvoiceCostsTable'
    import ProformaInvoiceSalesTable from './ProformaInvoiceSalesTable'
	import ProformaInvoiceInCharge from './ProformaInvoiceInCharge'
	import ProformaInvoiceTotal from './ProformaInvoiceTotal'
    import apiCars from '../../../../api/apiCars'
    export default {
        props:['car'],
        components: {
            ProformaInvoiceSettings,
            ProformaInvoiceDates,
            ProformaInvoiceSubTotal,
            ProformaInvoiceCostsTable,
            ProformaInvoiceSalesTable,
            ProformaInvoiceInCharge,
            ProformaInvoiceTotal
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/ProformaInvoice/ProformaInvoiceBody.vue